<section class="reminder-action banner-section" (click)="openConsultation()">
  <img class="chat-image card" [src]="imageUrl" />
</section>